


<span *ngIf="!licenseValid" class="hideOnLowResolution">
 Free version -  <a href="/#/license">{{ !licenseValid ? 'Purchase the PRO license' : ''}}</a>
</span>
<span *ngIf="licenseValid" class="hideOnLowResolution">
  PRO version -  <a href="/#/license">Check purchase history</a>
</span>
